module.exports = __webpack_public_path__ + "002e80eaa322f7a78dd1bc9dc47ee9ee.fbx";